// extracted by css-extract-rspack-plugin
export default {"root":"GrcpCW5Jy4AYpEkk"};